export const state = () => ({
    devices: {
        total: 0,
        totalPages: 0,
        data: [],
    },
    deviceStats: {},
})

export const actions = {
    async getDevices({ commit }, params) {
        await this.$axios
            .get('/operators/devices', { params })
            .then((response) => {
                commit('setDevices', response.data)
            })
            .catch(() => {
                return false
            })
    },
    async addDevice({ commit }, body) {
        const addResponse = await this.$axios
            .post('/operators/devices', body)
            .then((response) => {
                return true
            })
            .catch(() => {
                return false
            })
        return addResponse
    },
    async updateDevice({ commit }, { id, body }) {
        const updateResponse = await this.$axios
            .put(`/operators/devices/${id}`, body)
            .then((response) => {
                return true
            })
            .catch(() => {
                return false
            })
        return updateResponse
    },
    async deleteDevice({ commit }, { id, operatorId }) {
        const deleteResponse = await this.$axios
            .delete(`/operators/devices/${id}`, {
                params: { operator_id: operatorId },
            })
            .then((response) => {
                return true
            })
            .catch(() => {
                return false
            })
        return deleteResponse
    },
    async uploadDevices({ commit }, body) {
        const uploadResponse = await this.$axios
            .post('/operators/devices/upload', body)
            .then((response) => {
                return true
            })
            .catch(() => {
                return false
            })
        return uploadResponse
    },
    async getDeviceStats({ commit }, params) {
        await this.$axios
            .get('/operators/summary/device', { params })
            .then((response) => {
                commit('setDeviceStats', response.data)
            })
            .catch(() => {
                return false
            })
    },
}

export const mutations = {
    setDevices(state, data) {
        state.devices = data
    },
    setDeviceStats(state, data) {
        state.deviceStats = data
    },
}
